export default function CommunityHall({ formData, setFormData }) {
  const handleAddForm = () => {
    let data = {
      id: '',
    };
    setFormData((prevState) => [...prevState, data]);
  };

  const removeForm = (index) => {
    const updatedData = formData?.filter((_, i) => i !== index);
    setFormData(updatedData);
  };

  return (
    <div className="schema-form-array col-xs-12">
      <label className="control-label ng-binding">Community Hall Details</label>
      <ol className="list-group ng-pristine ng-untouched ng-valid">
        {formData?.length > 0 &&
          formData?.map((item, index) => {
            return (
              <li className="list-group-item" key={index}>
                <button
                  onClick={() => removeForm(index)}
                  ng-hide="form.readonly || form.remove === null"
                  style={{ position: 'relative', zIndex: '20' }}
                  type="button"
                  className="close pull-right"
                >
                  <span aria-hidden="true">×</span>
                  <span className="sr-only">Close</span>
                </button>
                <fieldset ng-disabled="form.readonly" className="schema-form-fieldset ">
                  <legend ng-className="{'sr-only': !showTitle() }" className="ng-binding">
                    Add Community Hall Details
                  </legend>
                  <div className="help-block ng-binding ng-hide"></div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label" for="adinventory_id">
                      Community Hall Location
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control ng-valid-schema-form"
                      id="adinventory_id"
                      ng-disabled="form.readonly"
                      name="adinventory_id"
                      aria-describedby="adinventory_idStatus"
                      ng-model="item['adinventory_id']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group  schema-form-select has-feedback">
                    <label className="control-label " ng-show="showTitle()">
                      Inventory Status
                    </label>
                    <select
                      ng-disabled="form.readonly"
                      className="form-control ng-valid-schema-form"
                      name="pole_hoarding_type"
                    >
                      <option value="?" selected="selected"></option>
                      <option label="Available" value="Big">
                        Available
                      </option>
                      <option label="Expired" value="Expired">
                        Expired
                      </option>
                    </select>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Community Hall Length(l*b)
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Community Hall Breadth(l*b)
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Ceiling height
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group  schema-form-select has-feedback">
                    <label className="control-label " ng-show="showTitle()">
                      Furniture Available
                    </label>
                    <select
                      ng-disabled="form.readonly"
                      className="form-control ng-valid-schema-form"
                      name="pole_hoarding_type"
                    >
                      <option value="?" selected="selected"></option>
                      <option label="Yes" value="Yes">
                        Yes
                      </option>
                      <option label="No" value="No">
                        No
                      </option>
                    </select>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Chair Count
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Tables Count
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group  schema-form-select has-feedback">
                    <label className="control-label " ng-show="showTitle()">
                      Air Conditioned Hall
                    </label>
                    <select
                      ng-disabled="form.readonly"
                      className="form-control ng-valid-schema-form"
                      name="pole_hoarding_type"
                    >
                      <option value="?" selected="selected"></option>
                      <option label="Yes" value="Yes">
                        Yes
                      </option>
                      <option label="No" value="No">
                        No
                      </option>
                    </select>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Current Community Hall Rentals/Day
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group  schema-form-select has-feedback">
                    <label className="control-label " ng-show="showTitle()">
                      Projector Available
                    </label>
                    <select
                      ng-disabled="form.readonly"
                      className="form-control ng-valid-schema-form"
                      name="pole_hoarding_type"
                    >
                      <option value="?" selected="selected"></option>
                      <option label="Yes" value="Yes">
                        Yes
                      </option>
                      <option label="No" value="No">
                        No
                      </option>
                    </select>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Opening Timings
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Closing Timings
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Community Hall Siting
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group  schema-form-select has-feedback">
                    <label className="control-label " ng-show="showTitle()">
                      Audio Video Display Availability
                    </label>
                    <select
                      ng-disabled="form.readonly"
                      className="form-control ng-valid-schema-form"
                      name="pole_hoarding_type"
                    >
                      <option value="?" selected="selected"></option>
                      <option label="Yes" value="Yes">
                        Yes
                      </option>
                      <option label="No" value="No">
                        No
                      </option>
                    </select>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Electricity Charges(Hourly)
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Daily price (Society)
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <div className="form-group schema-form-text has-feedback">
                    <label className="control-label " for="pole_area">
                      Daily price (Business)
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="form-control  ng-valid-schema-form"
                      id="pole_area"
                      ng-disabled="form.readonly"
                      name="pole_area"
                      aria-describedby="pole_areaStatus"
                      ng-model="item['pole_area']"
                    />
                    <span
                      className="form-control-feedback ng-scope glyphicon"
                      ng-className="evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': hasSuccess(), 'glyphicon-remove': hasError() }"
                      aria-hidden="true"
                    ></span>
                  </div>
                </fieldset>
              </li>
            );
          })}
      </ol>
      <div
        className="clearfix ng-untouched ng-valid ng-valid-schema-form ng-dirty"
        style={{ padding: '15px' }}
      >
        <button onClick={handleAddForm} type="button" className="btn btn-default pull-right">
          <i className="glyphicon glyphicon-plus"></i> Add
        </button>
      </div>
    </div>
  );
}
